<template>
  <div class="entry-container">
    <div class="infos">
      <h2>
        {{ enterpriseName }}
        <small style="margin: 0 5px">({{ $t("survey.CBENumber") }}: {{ enterpriseNumber }})</small> / <small>{{ activityName }}</small>
      </h2>
      <table class="survey-list-table">
        <tr>
          <th></th>
          <th>{{ $t("survey.startedAt") }}</th>
          <th>{{ $t("survey.updatedAt") }}</th>
          <th class="text-center">{{ $t("survey.statusTitle") }}</th>
          <th>{{ $t("survey.username") }}</th>
          <th></th>
        </tr>
        <SurveyEntry
          v-for="item in surveys"
          :key="item.sessionId"
          :id="item.sessionId"
          :namespace="item.namespace"
          :startedAt="item.startedDate"
          :updatedAt="item.lastUpdatedAt"
          :status="item.status"
          :username="item.username"
          :userId="item.userId"
          :disabled="loading"
          :serviceUnavailable="serviceUnavailable"
          :editable="item.editable"
          :archived="item.archived"
          :lastLoginAt="lastLoginAt"
          @continueSurvey="$emit('continueSurvey', item.sessionId, item.namespace)"
          @viewResult="$emit('viewResult', item.sessionId, item.namespace)"
          @viewPDFResult="$emit('viewPDFResult', item.sessionId)"
          @editData="$emit('editData')"
          @shareData="$emit('shareData', item)"
          @compareData="$emit('compareData', item)"
        />
      </table>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import SurveyEntry from '@/components/SurveyList/SurveyEntry.vue';

export default {
  name: 'ProfileEntry',
  props: {
    enterpriseName: String,
    enterpriseNumber: String,
    activityName: String,
    lastLoginAt: String,
    surveys: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
    serviceUnavailable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SurveyEntry,
  },
  methods: {
    convertDate(d) {
      let date;
      if (d) {
        date = format(new Date(d), 'dd/MM/yyyy HH:mm');
        return date;
      }
      return date;
    },
  },
};
</script>

<style>
.entry-container {
  border: 1px solid #eee;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1em 1.5em;
  margin: 0 0 1.5em 0;
}
.infos {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.infos h2 {
  margin: 0;
  padding: 0;
  color: black;
  font-size: 18px;
  font-weight: bold;
}
.infos h2 small {
  font-size: 14px;
  font-weight: 100;
}
.infos p {
  margin: 0;
  padding: 0;
  margin-top: 0.5em;
  font-size: 14px;
}
.badge {
  border-radius: 4px;
  padding: 2px 6px;
  background-color: #999;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.badge.inProgress, .badge.badge-blue {
  background-color: #0D93D2;
}
.badge.completed {
 background-color: #699E24;
}
.badge.notStarted {
  background-color: #736994;
}
.survey-list-table {
  width: 100%;
  margin-top: 1em;
}
.survey-list-table th {
  font-weight: bold;
  text-align: left;
  padding-bottom: 0.25em;
}
.text-center {
  text-align: center !important;
}

@media only screen and (max-width: 768px) {
  .entry-container {
    flex-direction: column;
  }
}
</style>
